const razorpayConfig = {
    key_id:'rzp_test_yhlBbwAK65HdVh',
    key_secret:'kyMGAJUfymInSss8XfhSsLZw'
}
export {
    razorpayConfig
}